



















































import Vue from 'vue'
import Component from 'vue-class-component'
import { State } from 'vuex-class'

import {
  projectVariables
} from '../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'


@Component({
  components: {},
  filters: {
    caplocks (value: string) {
      if (!value) return ''
      return value.toUpperCase()
    }
  }
})
class App3PleaseDonate extends Vue {
  @State('isMobileDevice') isMobileDevice?: boolean

  projectName: string = projectVariables.projectName
  donateUrl: string = projectVariables.projectWebsiteUrlTable.donateUrl

  openInNewTab (url: string) {
    window.open(url, '_blank')!.focus()
  }
}

export default App3PleaseDonate
